export default __webpack_public_path__ + "static/miceBanner_768-374cf8a2d25b05cf1256d58112827d2c.jpg";